/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/*
 * UserPreferences Action Type
 */
import ReduxUtils from '../../utils/ReduxUtils';
import { LIBRARY_ROOT } from '../../utils/Constants';
/**
 * Sets the language.
 */

var CHANGE_LANGUAGE = ReduxUtils.generateActionType(LIBRARY_ROOT, 'LanguageDropdown', 'CHANGE_LANGUAGE');
export default {
  CHANGE_LANGUAGE: CHANGE_LANGUAGE
};